import { asyncModal } from "@/components/ui/modal/utils";
import UserProfileModal from "@/components/user/UserProfileModal";

export default function showProfile(user = null, isRegistred = false) {
  return asyncModal({
    name: "user-profile",
    component: UserProfileModal,
    props: {
      user,
      isRegistred
    }
  });
}
